import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=c8a9ec84&scoped=true&"
var script = {}
import style0 from "./bottom.vue?vue&type=style&index=0&id=c8a9ec84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a9ec84",
  null
  
)

export default component.exports